import { HighChartDataBase } from './high-chart-data-base';
import { ChartSerie } from './chart-serie';
import { ChartPoint } from './chart-point';

export class PieHighChartData extends HighChartDataBase {

    protected calculateSerie(jsonData: any): ChartSerie {
        let output = new ChartSerie();
        output.name = jsonData['Name'];
        output.stack = jsonData['Stack'];
        output.type = jsonData['Type'];
        output.color = jsonData['Color'];
        if (jsonData['Data'] && jsonData['Data'].length > 0) {
            jsonData['Data'].forEach((point: any) => {
                output.data.push(new ChartPoint(point));
            });
        }
        return output;
    }

    public getHighChartOptions(): Object {
        return {
            accessability: { enabled: false },
            chart: {
                type: 'pie',
                height: this.chartHeight,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false
            },
            title: { 
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: { 
                text: this.chartSubTitle ,
                widthAdjust: -150
            },
            series: this.chartSeries,
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                        style: {
                            color: '#333'
                        },
                        connectorColor: 'silver'
                    }
                }
            },
            tooltip: {
                headerFormat: '<u style="font-size:11px">{point.key}</u><table>',
                pointFormat: (this.chartSeries.length > 1 ? '<tr><td style="padding:0 5px 0 0; font-weight:500"><i class="fa fa-circle" style="color:{series.color}"></i>&ensp;{series.name}: </td>' : "<tr>") + "<td><b>{point.y}</b></td></tr>",
                footerFormat: '</table>',
                valueSuffix: this.displayUnit,
                useHTML: true
            },
            colors: this.defaultColors,
            legend: {
                enabled: this.chartSeries.length > 1 ? true : false
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };
    }

}
